const urlFormat = input => {
	return input.replace(/[^a-z0-9]/gi, '_').toLowerCase()
}

export default urlFormat
